<div>
  <div class="db-first-half">
    <h1 class="mb8" >
      What type of website are you creating?
    </h1>
    <h5 class="mb40">
      This helps us guide your experience.
    </h5>

    <div class="ds-input-wrap {{companyTypesForView}} mb9">
      <h4>
        <span class="ds-input-label mb6">Please select your business type</span>
      </h4>
      <ds-dropdown
        [value]="selectedCompanyType"
        [smallSize]="true"
        [dsDropdownOptions]="companyTypesForView"
        [showDropDown]="false"
        [dsDropdownWithSearchIcon]="true"
        dsDropdownPlaceHolder="Search for your business or site type"
        [dsDropdownSearch]="true"
        [dsDropdownWithArrowIcon]="false"
        (onOptionChoose)="selectCompanyType($event)"
        (searchOutside)="searchCategory($event)"
      ></ds-dropdown>
    </div>

  </div>
  <div class="create-ai-assistant-form-view__action-wrap first-step" *ngIf="!!isMobile">

    <button class="ds-btn-black ds-btn-max"
            [ngClass]="{'ds-btn-disabled': (builderInteractionsService.disableNextButton|async)}"
            (click)="mobileNext.emit()"><span *ngIf="!(isMobile && selectedCompanyType && (builderInteractionsService.disableNextButton|async))">Next</span>
      <db-loading-circular-spinner *ngIf="isMobile && selectedCompanyType && (builderInteractionsService.disableNextButton|async)"></db-loading-circular-spinner>
    </button>
  </div>
</div>
